<template>
  <div class="section-wrapper">
    <div class="sec6-trigger"></div>
    <div class="left-side sec-6-left-side">
      <div class="left-side-inner">
        <div class="left-side-title">
          <h4>Znamy się od kuchni ... czyli poddajemy sprzęt Amica domowym testom!</h4>
        </div>
        <video-carousel></video-carousel>
      </div>
    </div>
    <div class="right-side sec-6-right-side">
      <div class="right-side-inner">
        <h2>Kierunek: kuchnia!</h2>
        <p>Projektując swoje produkty myślimy o tym, jaki wpływ będą one miały na życie zwykłego człowieka. Przedmiotem naszego zainteresowania są jego oczekiwania, problemy, doświadczenia, pomysły. Interesuje nas wszystko, co wpływa na komfort działania w kuchni, dlatego też po raz kolejny zdecydowaliśmy się na realizację badań etnograficznych w polskich domach.</p>
        <p>
          <strong>2 lata, 100 rodzin i ponad 130 przetestowanych sprzętów.</strong> To efekt naszego przywiązania do idei „projektowania po ludzku”. To dowód na to, że tworzone przez nas produkty AGD służą codzienności i w sposób maksymalnie skuteczny oraz intuicyjny ułatwiają kuchenne prace!
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import videoCarousel from "./video_carousel";
export default {
  
  computed: {
    imageUrl: function() {
      return window.pageContentData.params.images["img-sec-2"];
    }
  },
  components: {
    videoCarousel
  }
};
</script>

<style lang="scss" scoped>
.section-wrapper {
  width: 100%;
  height: auto;
  position: relative;
  align-items: center;
  padding: 4rem 0 4rem;
  display: flex;
  background-color: #fff;
  z-index: 2;
  &::after {
    content: "";
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #e6cbc2;
    opacity: 0.2;
    z-index: -1;
  }
  &::before {
    content: "";
    display: flex;
    width: 150px;
    height: 140px;
    background: url("../../../assets/images/zpl/dots-black-red.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: absolute;
    bottom: 15px;
    right: -27px;
    z-index: 1;

    @media only screen and (max-width: 1366px) {
      display: none;
    }
  }
  @media only screen and (max-width: 1024px) {
    min-height: auto;
    height: auto;
    padding: 4rem 0;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 2rem 0;
  }

  .left-side {
    height: 100%;
    width: 59.33vw;

    @media only screen and (max-width: 768px) {
      width: 100%;
    }

    .left-side-inner {
      padding-left: 8.3333vw;
      position: relative;
      &::before {
        content: "";
        display: flex;
        width: 150px;
        height: 140px;
        background: url("../../../assets/images/zpl/splash-pink-faded.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        position: absolute;
        bottom: -41px;
        right: -29px;
        z-index: 1;

        @media only screen and (max-width: 1366px) {
          display: none;
        }
      }
      &::after {
        content: "";
        display: flex;
        width: 370px;
        height: 400px;
        background: url("../../../assets/images/zpl/splash-circle-pink.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        position: absolute;
        top: 79px;
        right: -86px;
        z-index: -1;

        @media only screen and (max-width: 1366px) {
          display: none;
        }
      }

      @media only screen and (max-width: 768px) {
        padding-left: 0px;
        // padding-right: 8.33%;
      }

      img {
        width: 100%;
        max-width: 100%;

        @media only screen and (max-width: 768px) {
          margin-bottom: 2rem;
        }
      }
      .left-side-title {
        display: flex;
        position: relative;
      
        h4 {
          display: inline-flex;
          color: #e41429;
          font-size: 1.3rem;
          margin-left: 10px;
          margin-bottom: 2rem;
          font-weight: 600;
          margin-top: auto;
          width: 100%;
          padding-top: 4rem;

          @media only screen and (max-width: 1024px) {
            font-size: 1.5rem;
            text-align: center;
       
          }
        }
        &::before {
          content: "";
          display: flex;
          width: 120px;
          height: 85px;
          background: url("../../../assets/images/zpl/dots-multicolors.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          position: absolute;
          top: -58px;
          left: 75px;

          @media only screen and (max-width: 1366px) {
            display: none;
          }
        }
        &::after {
          content: "";
          display: flex;
          width: 135px;
          height: 120px;
          background: url("../../../assets/images/zpl/splash-red.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          position: absolute;
          left: -168px;
          top: 68px;

          @media only screen and (max-width: 1366px) {
            display: none;
          }
        }
      }
    }
  }

  .right-side {
    height: 100%;
    width: 50%;
    position: relative;

    @media only screen and (max-width: 768px) {
      width: 100%;
    }

    .right-side-inner {
      padding-left: 8.33vw;
      width: 32.32vw;
      height: 100%;
      box-sizing: content-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      @media only screen and (max-width: 768px) {
        padding-left: 8.33%;
        padding-right: 8.33%;
        width: calc(100% - 8.33% - 8.33%);
      }

      h2 {
        color: #e41429;
        font-size: 3.2rem;
        margin-bottom: 2rem;
        font-weight: 600;
        margin-top: auto;
        width: 100%;

        @media only screen and (max-width: 1024px) {
          font-size: 2.2rem;
        }
      }

      p {
        margin-bottom: 2rem;
        width: 80%;

        @media only screen and (max-width: 768px) {
          margin-bottom: auto;
          width: 100%;
        }
      }
    }
  }
}
</style>
